// extracted by mini-css-extract-plugin
module.exports = {"btnIcon":"Styles_btnIcon__Hf73t"};